const alt = require('components/alt');
const LPClient = require('components/lp_client');

class LPListingsActions {
  lpListingsLoaded(listings) {
    return listings;
  }

  loadListings(ids) {
    return LPClient.fetchListings(ids).then((response) => {
      this.lpListingsLoaded(response.listings);
    }).catch((err) => {
      throw err;
    });
  }
}

module.exports = alt.createActions(LPListingsActions);



// WEBPACK FOOTER //
// ./javascripts/components/lp_listings/lp_listings_actions.js